import { useTranslation } from "react-i18next";
import type { BlobItem } from "@azure/storage-blob";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";
import { useBlobViewer } from "@/hooks/dashboard/useBlobViewer";
import { BlobContentRenderer } from "./BlobContentRenderer";

interface BlobViewerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  blob: BlobItem | null;
}

export function BlobViewerDialog({ open, onOpenChange, blob }: BlobViewerDialogProps) {
  const { t } = useTranslation();
  const blobViewer = useBlobViewer(blob, open);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <FileText className="w-5 h-5 mr-2" />
            {blob?.name || t("common.fileViewer")}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-hidden">
          <BlobContentRenderer blob={blob} blobViewer={blobViewer} />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("common.close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
